/** @format */

import { theme as baseTheme, extendTheme } from '@chakra-ui/react';

const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  cssVarPrefix: 'TBH',
};
const { Button, Switch } = baseTheme.components;
export const theme = extendTheme({
  config,
  colors: {
    brandOrange: '#FF5403',
    pureBlack: '#0000',
    primaryBlack: '#131316',
    secondaryBlack: '#171717',
    secondaryGreen: '#059964',
    secondaryYellow: '#E9AD14',
    secondaryRed: '#E11900',
    black: {
      300: '#010101',
    },
    gray: {
      0: '#EFF1F6',
      100: '#DBDEE5',
      300: '#888F95',
      400: '#56616B',
      500: '#31373D',
      800: '#131316',
    },
    shakeGrey: {
      100: '#465869',
    },
    textPrimary: {
      100: '#4D5155',
    },
    brandGray: {
      100: '#E5E8F0',
      200: '#D6D9E0',
      300: '#91989E',
      400: '#4D5760',
    },
    jade: {
      100: '#E3FCF2',
      400: '#0EA163',
      500: '#075132',
    },
    neon: {
      100: '#E5FCE3',
      500: '#0D5107',
    },
    maya: {
      300: '#15BDF2',
    },
    red: {
      100: '#F9E3E0',
      300: '#E11900',
      400: '#961100',
    },
    purple: {
      50: '#F0E5FF',
      100: '#EDE5FE',
      500: '#230C54',
      900: '#150033',
      card500: '#5500CC',
      700: '#350080',
    },
    pink: {
      300: '#FF4D97',
    },
    teal: {
      500: '#00AACC',
    },
    yellow: {
      100: '#FEF7E5',
      500: '#533D03',
    },
    orange: {
      100: '#FFEEE5',
      500: '#551C01',
    },
    blue: { 600: '#005AB2' },
    grayArrow: '#1C1B1F',
    chartPurple: '#844FF6',
    blackGray: '#1F2A35',
    brand: {
      grey: '#EFF1F6',
      red100: '#F9E3E0',
      black200: '#1D1D1F',
      black300: '#131316',
      grey300: '#888F95',
      green100: '#E3FCF2',
      yellow100: '#FEF7E5',
      gray100: '#DBDEE6',
    },
  },
  fonts: {
    heading: `Degular Display, ${baseTheme.fonts?.heading}`,
    body: `Degular, ${baseTheme.fonts?.body}`,
  },
  fontSizes: {
    h2: '56px',
    h5: '20px',
    h6: '18px',
    p: '16px',
    body: '16px',
    button: '17px',
    mini: '16px',
    small: '14px',
  },
  lineHeights: {
    h2: '67.2px',
    h5: '24px',
    h6: '25.2px',
    p: '25.6px',
    body: '25.6px',
    button: '20.4px',
  },
  components: {
    Button,
    Switch,
  },
  breakpoints: {
    ...baseTheme.breakpoints,
    // base: '0px',
    // xs: '321px',
    // sm: '400px',
    // md: '600px',
    // lg: '960px',
    xxl: '1440px',
    // '2xl': '1920px',
  },
  shadows: {
    paginator_shadow: '0px 7px 16px rgba(0, 0, 0, 0.14);',
    toaster_shadow: '0px 8px 16px 4px rgba(188, 196, 204, 0.12);',
  },
});
